import React, { Component } from 'react'
import moment from 'moment'
import { convertCents } from '../../utils'
import NumberFormat from 'react-number-format'
import getSymbolFromCurrency from 'currency-symbol-map'
import './priceSummary.css'
import PricingBanner from '../pricingBanner/pricingBanner'
import Tippy from '@tippyjs/react'
import { auth } from 'components/auth/auth'

const rentalInfoTypes = ['daily_rental', 'delivery_fees', 'service_fee_total']

const shortRentalInfoTypes = [
  'daily_rental',
  'service_fee_total',
  'delivery_fees',
  'multi_day_discount',
  'daily_rental_referral_free_day',
  'daily_rental_referral_discount',
]

const addOnTypes = ['roadside_assistance', 'tire_protection', 'rider_insurance', 'increased_liability_protection']

const taxesFeesTypes = ['tax']

const cancellationFeesTypes = ['same_day_cancellation_penalty', 'booking_cancellation_fee',]

const defaultInsuranceLineItems = [
  {
    description: 'Insurance Plan',
    contra: false,
    type: 'rider_insurance',
    display: true,
  },
]

const PricingSection = ({
  shortSummary,
  lineItems,
  header,
  isSameDayRequest = false,
  defaultInsurance,
}) => {
  const className = shortSummary ? 'smaller-summary' : ''
  return (
    <React.Fragment>
      {lineItems.length > 0 && (
        <div className={'pricing-summary-section ' + className}>
          {!shortSummary && (
            <span className="pricing-section-header">{header}</span>
          )}
          <div className="payment-page-line-items">
            {lineItems.map((item, i) => (
              <Item
                item={item}
                key={i}
                header={header}
                defaultInsurance={defaultInsurance}
                lineClassName={
                  item.contra
                    ? `${
                        cancellationFeesTypes.includes(item.type)
                          ? 'has-text-danger'
                          : 'contra has-text-color-success'
                      }`
                    : ''
                }
                isSameDayRequest={isSameDayRequest}
              />
            ))}
          </div>
        </div>
      )}
      {defaultInsurance == false && (
        <div className={'pricing-summary-section ' + className}>
          {!shortSummary && (
            <span className="pricing-section-header">{header}</span>
          )}
          <div className="payment-page-line-items">
            {defaultInsuranceLineItems.map((item, i) => (
              <InsuranceDefaultItem
                item={item}
                key={i}
                header={header}
                defaultInsurance={defaultInsurance}
                lineClassName={
                  item.contra
                    ? `${
                        cancellationFeesTypes.includes(item.type)
                          ? 'has-text-danger'
                          : 'contra has-text-color-success'
                      }`
                    : ''
                }
              />
            ))}
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

const Item = ({
  item,
  lineClassName,
  header,
}) => {
  const getClassname = (item) => {
    return ['daily_rental_referral_free_day', 'daily_rental_referral_discount'].includes(item.type) ?
      'summary-info is-flex is-flex-grow-3 is-align-content-center' : 'summary-info'
  }
  return (
    <React.Fragment>
      {item.display && (
        <div className={'is-flex summary-line-item line-type ' + lineClassName}>
          <div className={getClassname(item)}>
            {item.description} {header === 'Insurance' ? <br /> : null}
            {item.misc_info !== null ? (
              <span className="price-misc-info">{item.misc_info}</span>
            ) : null}
            {item.description.includes('Community Fee') && !item.contra && (
              <Tippy
                className="custom-tippy"
                zIndex={99999}
                content="We use this fee to provide 24/7 customer support, maintain our website, complete DMV background checks on all riders, and subsidize the cost of insurance on every ride."
              >
                <span className="icon is-small mt-1">
                  <i className="fas fa-info" style={{ color: '#695626' }}></i>
                </span>
              </Tippy>
            )}
            {['daily_rental_referral_free_day', 'daily_rental_referral_discount'].includes(item.type) && (
              <Tippy
                className="custom-tippy"
                zIndex={99999}
                content="Discount applies to first-time riders only"
              >
                <span className="icon is-small pl-2 referral-disc-tippy">
                  <i className="fas fa-info" style={{ color: '#695626' }}></i>
                </span>
              </Tippy>
            )}
          </div>
          <div className="summary-price">
            <span>
              {item.contra && <React.Fragment>-</React.Fragment>}
              {item.amount_cents == "Declined" ?
                <p className='empty-insurance'>Declined</p>
                  :
                <>
                  {header === 'Insurance' ? <br /> : null}
                  <NumberFormat
                    value={item.amount_cents / 100}
                    displayType={'text'}
                    thousandSeparator={true}
                    prefix={getSymbolFromCurrency(item.amount_currency)}
                    decimalScale={2}
                    fixedDecimalScale={true}
                  />
                </>
              }
            </span>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

const InsuranceDefaultItem = ({
  item,
  lineClassName,
  header,
  defaultInsurance,
}) => {
  return (
    <React.Fragment>
      {item.display && (
        <div className={'is-flex summary-line-item line-type ' + lineClassName}>
          <div className="summary-info">{item.description} </div>
          <div className="summary-price">
            <span>
              {item.contra && <React.Fragment>-</React.Fragment>}
              {!defaultInsurance && header === 'Insurance' ? (
                <p className="empty-insurance">Not Selected</p>
              ) : null}
            </span>
          </div>
        </div>
      )}
    </React.Fragment>
  )
}

class PaymentSummary extends Component {
  constructor(props) {
    super(props)
    this.state = {
      hasData: false,
      grandTotalCents: null,
      hasGrandTotal: false,
      hasPreDiscount: false,
      preDiscountCents: null,
      grandTotalCurrency: 'USD',
      preDiscountCurrency: 'USD',
      tripDetails: [],
      addOns: [],
      discounts: [],
      taxesFees: [],
      cancellationFees: [],
      hasMultiDay: false,
      multiDayCTA: '',
      multiDayApplied: false,
    }
  }

  componentDidMount() {
    this.parseNewPricingInfo()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.pricingInfo !== this.props.pricingInfo) {
      this.parseNewPricingInfo()
    }
  }

  parseNewPricingInfo = () => {
    if (!this.props.pricingInfo) {
      return false
    }

    let tripDetails = []
    let addOns = []
    let discounts = []
    let taxesFees = []
    let cancellationFees = []

    let discountTotal = 0 //HACK FOR MULTIDAY FOR NOW

    let pricing = JSON.parse(JSON.stringify(this.props.pricingInfo))

    if (!pricing.hasOwnProperty('line_items')) {
      return false
    }

    const tripDuation = this.props.endDate?.diff(this.props?.startDate, 'days')
    let hackedTotal = null

    //WE ARE HACKING THIS TO ADD REFERRAL DISCOUNT TO LINE ITEMS FOR NON LOGGED-IN USER
    if(tripDuation && !auth.isAuthenticated() && this.props.shortSummary) {
      if (tripDuation >= 4) {
        const referralFreeDayLineItem = {
          type: "daily_rental_referral_free_day",
          description: "1 Free Day Referral Discount",
          quantity: 1,
          contra: true,
          amount_cents: this.props.pricingInfo.totals.bike_rental_daily.bike_rental_daily_cents,
          amount_currency: this.props.pricingInfo.totals.bike_rental_daily.bike_rental_daily_currency,
          position: 110,
          display: true,
          misc_info: null,
          promo_info: {},
        }
        pricing.line_items.push(referralFreeDayLineItem)
        hackedTotal = this.props.pricingInfo.totals.bike_rental_daily.bike_rental_daily_cents
      } else {
        // hack it and apply 20% discount
        const tempBikeRentalCost = this.props.pricingInfo.totals.bike_rental_total.bike_rental_total_cents || 0
        const discountedCost = tempBikeRentalCost * 0.20
        const referralDiscountLineItem = {
          type: "daily_rental_referral_discount",
          description: "20% Referral Discount",
          quantity: 1,
          contra: true,
          amount_cents: discountedCost,
          amount_currency: "USD",
          position: 114,
          display: true,
          misc_info: null,
          promo_info: {},
        }
        pricing.line_items.push(referralDiscountLineItem)
        hackedTotal = discountedCost
      }
    }

    for (let i = 0; i < pricing.line_items.length; i++) {
      if (!pricing.line_items[i].display) {
        continue
      }

      //WE ARE HACKING THIS TO HIDE SERVICE FEE FOR NOW ON SHORT SUMMARY
      if (
        pricing.line_items[i].type === 'service_fee_total' &&
        this.props.shortSummary
      ) {
        continue
      }

      if (this.props.shortSummary) {
        if (shortRentalInfoTypes.includes(pricing.line_items[i].type)) {
          tripDetails.push(pricing.line_items[i])
          if (pricing.line_items[i].contra) {
            // hack to add up discounts
            discountTotal = discountTotal + pricing.line_items[i].amount_cents
          }
          continue
        }
      }

      if (!this.props.shortSummary) {
        if (rentalInfoTypes.includes(pricing.line_items[i].type)) {
          tripDetails.push(pricing.line_items[i])
          continue
        }
      }

      //check to see if it's a base trip detail
      if (addOnTypes.includes(pricing.line_items[i].type)) {
        if (pricing.line_items[i].type == "rider_insurance" &&
              pricing.line_items[i].description.includes("Decline")
          ) {
          const tempLineItem = {
            ...pricing.line_items[i],
            description: "Insurance Plan",
            misc_info: null,
            amount_cents: "Declined"
          }
          addOns.push(tempLineItem)
        } else {
          addOns.push(pricing.line_items[i])
        }
        continue
      }

      //check to see if it is a cancellation fees
      if (cancellationFeesTypes.includes(pricing.line_items[i].type)) {
        cancellationFees.push(pricing.line_items[i])
        continue
      }

      //check to see if it is a discount & to hide multiday discount for less price bike from total bill
      if (pricing.line_items[i].contra) {
        discounts.push(pricing.line_items[i])
      }

      //check to see if it's a tax or fee
      if (taxesFeesTypes.includes(pricing.line_items[i].type)) {
        taxesFees.push(pricing.line_items[i])
        continue
      }
    }

    this.setState({
      hasData: true,
      tripDetails,
      addOns,
      discounts,
      taxesFees,
      cancellationFees,
      hasMultiDay: pricing.motorcycle.pricing.multi_day_discounts,
      multiDayCTA: pricing.motorcycle.pricing.multi_day_cta,
      multiDayApplied: pricing.request_details.multi_day_discount_applied,
    })

    //first we get the totals
    if (!this.props.pricingInfo.hasOwnProperty('totals')) {
      return false
    }

    // Exclude Applied credits, if required
    if (
      typeof this.props.pricingInfo.totals.applied_rider_credits
        .skip_applied_rider_credits != 'undefined' &&
      this.props.pricingInfo.totals.applied_rider_credits
        .skip_applied_rider_credits
    ) {
      discounts = discounts.filter((d, k) => {
        if (d.type == 'rider_credit_discount') {
          return false
        }
        return true
      })

      this.setState({
        discounts,
      })
    }

    if (this.props.shortSummary) {
      //Here we are testing hiding the service fee.
      //We are manually taking service fee off here.
      // const serviceTotal = this.props.pricingInfo.totals
      //   .service_fee_scheduled_total.service_fee_scheduled_total_cents
      // const grandTotal = this.props.pricingInfo.totals.short_summary_total
      //   .short_summary_total_cents
      // const deliveryFeesTotal =
      //   this.props.pricingInfo.totals.delivery_fees_total
      //     .delivery_fees_total_cents || 0
      // let grandNoService = grandTotal - serviceTotal + deliveryFeesTotal

      const deliveryFeesTotal = this.props.pricingInfo.totals.delivery_fees_total.delivery_fees_total_cents || 0
      let bikeRentalTotal = this.props.pricingInfo.totals.bike_rental_total.bike_rental_total_cents
      bikeRentalTotal += deliveryFeesTotal

      if(hackedTotal && hackedTotal > 0) {
        bikeRentalTotal -= hackedTotal
      }

      //const grandNoServiceWDiscounts = grandNoService - discountTotal //hack for multiday frontend
      this.setState({
        grandTotalCents: bikeRentalTotal,
        hasGrandTotal: true,
        grandTotalCurrency: this.props.pricingInfo.totals.bike_rental_total.bike_rental_total_currency,
      })

      //console.log('servie fee total', this.props.pricingInfo.totals.service_fee_total.service_fee_total_cents)
      //console.log('grand', this.props.pricingInfo.totals.service_fee_total.service_fee_total_cents)

      /*this.setState({
                grandTotalCents: this.props.pricingInfo.totals.short_summary_total.short_summary_total_cents,
                grandTotalCurrency: this.props.pricingInfo.totals.short_summary_total.short_summary_total_currency
            })*/
    } else {
      let totalDiscount = 0
      discounts.forEach((discount) => {
        totalDiscount += discount?.amount_cents
      })
      const totalWithDiscount =
        this.props.pricingInfo.totals.grand_total.grand_total_cents +
        totalDiscount
      this.setState({
        grandTotalCents: this.props.pricingInfo.totals.grand_total
          .grand_total_cents,
        hasGrandTotal: true,
        grandTotalCurrency: this.props.pricingInfo.totals.grand_total
          .grand_total_currency,
        hasPreDiscount: true,
        preDiscountCents: totalWithDiscount,
        preDiscountCurrency: discounts[0]?.amount_currency
          ? discounts[0]?.amount_currency
          : 'USD',
      })
    }

    if (this.props.cancelTripData) {
      this.setState({
        hasGrandTotal: false,
      })
    }
  }

  //Right now we are testing referrals manuals
  testReferrals = (lineTypes) => {
    if (lineTypes.find((e) => e.type === 'daily_rental_referral_free_day')) {
      return true
    }
    if (lineTypes.find((e) => e.type === 'daily_rental_referral_discount')) {
      return true
    }
    return false
  }

  render() {
    const {
      hasData,
      tripDetails,
      addOns,
      discounts,
      taxesFees,
      cancellationFees,
      hasGrandTotal,
      grandTotalCents,
      grandTotalCurrency,
      multiDayCTA,
      hasMultiDay,
      multiDayApplied,
      hasPreDiscount,
      preDiscountCents,
      preDiscountCurrency,
    } = this.state

    const {
      hideNoPricingMessage,
      shortSummary,
      bikeData,
      cancelTripData,
      isCheckoutPage,
      defaultInsurance,
      isMobile,
    } = this.props
    return (
      <div className={this.props.className}>
        {!hasData && !hideNoPricingMessage && (
          <React.Fragment>No pricing data found.</React.Fragment>
        )}

        {hasData && (
          <React.Fragment>
            {shortSummary &&
              hasMultiDay &&
              !multiDayApplied &&
              !this.testReferrals(tripDetails) &&
              convertCents(bikeData.base_bike_daily_price_cents) > 64 && (
                <PricingBanner message={multiDayCTA} />
              )}
            <PricingSection
              shortSummary={shortSummary}
              lineItems={tripDetails}
              header={'Trip Details'}
              isSameDayRequest={!!cancelTripData && cancelTripData.type === 'CREDIT_REFUND' && cancelTripData.is_same_day_request}
            />
            {!shortSummary && (
              <PricingSection
                shortSummary={shortSummary}
                lineItems={addOns}
                defaultInsurance={defaultInsurance}
                header={'Insurance'}
              />
            )}
            {!shortSummary && (
              <PricingSection
                shortSummary={shortSummary}
                lineItems={taxesFees}
                header={'Taxes and Fees'}
              />
            )}
            {!shortSummary && (
              <PricingSection
                shortSummary={shortSummary}
                lineItems={cancellationFees}
                header={'Cancellation Fees'}
              />
            )}
            {cancelTripData && (
              <div className="payment-page-line-items mt-1">
                <div className="is-flex line-type price-summary-total summary-line-item has-text-weight-extra-bold">
                  <div className="summary-info pl-4">
                    {cancelTripData.label}
                  </div>
                  <div className="summary-price pr-4">
                    <NumberFormat
                      value={convertCents(cancelTripData.valueCents)}
                      displayType={'text'}
                      thousandSeparator={true}
                      prefix={getSymbolFromCurrency(
                        cancelTripData.valueCurrency
                      )}
                      decimalScale={2}
                      fixedDecimalScale={true}
                    />
                  </div>
                </div>
              </div>
            )}
            {hasPreDiscount && (
              <div className={'pricing-summary-section '}>
                <span className="pricing-section-header">
                  Cost before discounts
                </span>
                <div className="payment-page-line-items mt-1">
                  <div className="is-flex line-type summary-line-item">
                    <div className="summary-info">Subtotal</div>
                    <div className="summary-price">
                      <NumberFormat
                        value={preDiscountCents / 100}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={getSymbolFromCurrency(preDiscountCurrency)}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
            {!shortSummary && (
              <PricingSection
                shortSummary={shortSummary}
                lineItems={discounts}
                header={
                  <span className="has-pricing-summary-grey">Discounts </span>
                }
              />
            )}
            {hasGrandTotal && (isCheckoutPage || isMobile) && (
              <div className={'pricing-summary-section '}>
                <span className="pricing-section-header">
                  Price you will pay
                </span>
              </div>
            )}
            {hasGrandTotal && (
              <>
                <div className="payment-page-line-items mt-1">
                  <div className="is-flex line-type price-summary-total summary-line-item has-text-weight-extra-bold has-black-dark-text">
                    <div className="summary-info pl-4">Grand Total</div>
                    <div className="summary-price pr-4">
                      <NumberFormat
                        value={grandTotalCents / 100}
                        displayType={'text'}
                        thousandSeparator={true}
                        prefix={getSymbolFromCurrency(grandTotalCurrency)}
                        decimalScale={2}
                        fixedDecimalScale={true}
                      />
                      {bikeData && bikeData.is_partner && <span>*</span>}
                    </div>
                  </div>
                </div>
                {isCheckoutPage && !defaultInsurance && (
                  <div className="show-summary">
                    <p className="insurance-cost">+ Insurance Cost</p>
                  </div>
                )}
              </>
            )}
          </React.Fragment>
        )}
        {!hasData && null //we silently fail for now
        }
      </div>
    )
  }
}

PaymentSummary.defaultProps = {
  pricingInfo: null,
  loading: false,
  hasPricingInfo: false,
  hasPricingError: false,
  className: '',
  shortSummary: false,
  hideNoPricingMessage: false,
  cancelTripData: null,
}
export default PaymentSummary
